import React from 'react'
import Validator from 'dataphi-react-components/dist/Containers/FormScreen/FormComponent/Validator'
import FaPowerOff from 'react-icons/lib/fa/power-off'

const loginBtn = (
  <div className="hsg-login-btn">
    <div className="hsg-login-btn-icon" >
      {<FaPowerOff size={20} />}
    </div>
    <p className="pull-right">
      &nbsp;Login
    </p>  
  </div>
)

const LoginDefs = {
  formHeader: 'Please fill in user details',
  submitButton: {  text: loginBtn, className: {
    fieldClassName: 'hsg-login-btn-block right',
    groupClassName: 'hsg-login-btn-content'
  }},
  closeButton: {  text: 'Cancel', className: '', hide: true}, 
  metaData:  [
              {
                name: 'username',
                type: 'email',
                className: { groupClassName: 'hsg-login-group usrname', fieldClassName: 'hsg-login-input', errorClassName: 'hsg-error' },
                placeholder: 'Username',
                validation: [Validator.required]
              },
              {
                name: 'password',
                type: 'password',
                className: { groupClassName: 'hsg-login-group passwd', fieldClassName: 'hsg-login-input', errorClassName: 'hsg-error' },
                placeholder: 'Password',
                validation: [Validator.required]
              },
              {
                name: 'rememberMe',
                type: 'checkbox',
                className: { 
                  fieldClassName: 'hsg-checkbox left',
                  groupClassName: 'hsg-login-input-grp col-md-6 col-sm-6 col-xs-6',
                  labelClassName: 'hsg-checkbox-label'
                  },
                label: '',
                options: [
                  {
                    label: 'Remember Me',
                    value: 'yes' 
                  }
                ],
                placeholder: 'Remember me'
              }
            ]
}

export default LoginDefs